import React from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion as MuiAccordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import styled from 'styled-components';

const StyledAccordion = styled(MuiAccordion)`
    padding: 12px 0; /* padding instead of margin keeps the dividers centered */
    max-width: 40rem;
`;

interface AccordionProps {
    title: string;
    children: React.ReactNode;
}

const Accordion: React.FC<AccordionProps> = ({ title, children }) => (
    <StyledAccordion elevation={0} disableGutters>
        <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            color="blue"
        >
            <Typography>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
    </StyledAccordion>
);

export default Accordion;
